//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'DashBoardWrapper',
  props: {
    menu: {
      default: () => ({ default: { label: 'default', component: null } }),
      type: Object,
      required: true,
    },
    defaultActive: {
      default: '',
      type: String,
    },
    lecturer: { type: Boolean, default: false },
    owner: { type: Boolean, default: false },
  },
  data() {
    return {
      activeTab: this.defaultActive || Object.keys(this.menu)[0],
      activeSubTab: '',
      selectTabKey: '',
    };
  },
  computed: {
    ...mapGetters('user', ['token']),
    activeComponent() {
      if (this.activeSubTab) {
        return this.menu[this.activeTab].children[this.activeSubTab].component;
      }
      return this.menu[this.activeTab].component;
    },
  },
  methods: {
    changeTab(key, subKey = null, active = true) {
      if (!active) return;

      this.activeTab = key;
      this.selectTabKey = key;
      this.activeSubTab = subKey;

      if (subKey) {
        this.$router.push({
          path: this.$route.path,
          query: { tab: key, subTab: subKey },
        });
        return;
      }
      this.$router.push({ path: this.$route.path, query: { tab: key } });
    },
    selectTab(key) {
      if (this.selectTabKey === key) return (this.selectTabKey = '');
      this.selectTabKey = key;
    },
    updateTabs() {
      const tab = this.$route.query.tab;
      const subTab = this.$route.query.subTab;
      const hasTab = Object.keys(this.menu).includes(tab);

      if (tab && hasTab) {
        this.activeTab = tab;
        if (subTab) this.activeSubTab = subTab;
      }
    },
  },
  watch: {
    '$route.query'() {
      // query 改變時相對應 menuTabs 跟著改變
      this.updateTabs();
    },
    token() {
      // 點左側選單登出再登入後 分頁切換到第一項
      if (this.token)
        this.activeTab = this.defaultActive || Object.keys(this.menu)[0];
    },
  },
  created() {
    this.updateTabs();
  },
};
